module.exports = __webpack_public_path__ + "officialStatic/img/solution-wx-zz.ed2c337.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-wx-zz.png
// module id = ujEI
// module chunks = 0